exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flipper{position:relative;z-index:1;width:50px;height:100px;display:inline-block}.flipper__wrapper{width:100%;height:100%;backface-visibility:hidden;-webkit-backface-visibility:hidden;transform-style:preserve-3d;-webkit-transform-style:preserve-3d;transition:transform .7s}.flipper--flipped .flipper__wrapper{transform:rotateY(180deg)}.flipper__face{position:absolute;width:100%;height:100%}.flipper__face.flipper__face--back{transform:rotateY(180deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0509d378","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/flipper/flipper.vue
// module id = 49
// module chunks = 0